// Returns BOTH Authorization and X-Id-Token with the current Firebase ID token,
// for calls to the (now auth-protected) backend proxy. The server reads
// X-Id-Token first, leaving Authorization free for routes that carry a courier
// bearer token (e.g. Shiprocket) without colliding with Firebase auth.
// Empty object if no user / token.
import { auth } from '../../integrations/firebase';

export const authHeaders = async () => {
    try {
        const token = await auth.currentUser?.getIdToken?.();
        return token ? { Authorization: `Bearer ${token}`, 'X-Id-Token': token } : {};
    } catch (e) {
        return {};
    }
};
